import {Card} from "@web-libs/ui/ui-components/card/card";
import ErrorIcon from "@web-libs/ui/svgs/icons/ErrorIcon";
import {Text} from "@web-libs/ui/ui-components/typo/text";

export const ErrorCard = ({text}:{text:string}) => {

    const _cardStyles = {
        maxWidth:400,
        borderRadius:20
    }

    const _textStyles = {
        marginTop:4
    }

    return (
        <Card style={_cardStyles} padding={24} color={"warn"}>
            <div><ErrorIcon color={"light"}></ErrorIcon></div>
            <Text block style={_textStyles}>{text}</Text>
        </Card>
    )
}
